import { useRouter } from 'vue-router'

import { withQuery } from '@maxsystems/client'

import ACVOffer from './ACVOffer.vue'
import inventoryReportOfferQuery from './queries/inventoryReportOffer.gql'
import updateOfferStateQuery from './queries/updateOfferState.gql'
import { useAuth } from '~/plugins/auth'

const getInventoryReport = withQuery(inventoryReportOfferQuery)
const updateOfferState = withQuery(updateOfferStateQuery)

const RouteWithProvide = {
  setup () {
    const auth = useAuth()
    const router = useRouter()

    if (!auth.dealer?.hasACVGuarantee) {
      router.push('/')
      return
    }

    provide('actions', {
      getInventoryReport,
      updateOfferState
    })

    return () => h(ACVOffer)
  }
}

export default [
  {
    component: RouteWithProvide,
    name: 'reports.inventory.offer',
    path: '/reports/inventory/offer'
  }
]
